export const isProPlan = (planId: string | undefined): boolean =>
  planId === "pro";


